import { useEffect, useState } from 'react';
import { getMenuType, isEmpty, isFormValid, isSchoolAdmin, isSuperAdmin, setError, syncProfileMarker } from '../../../../library/Core/SmartFunctions';
import { ControlOnChangeArguments, DispatchEvent, State } from '../../../../library/Core/SmartTypes';
import logger from '../../../../library/Core/logger';
import ScreenNavigationService, { AlumniProfileEditScreens } from '../../../../services/screen-navigation.service';
// import { toStudentEntity } from '../../../../services/student-mapper.service';
import StudentService from '../../../../services/student.service';
import { navigateToNextStep } from '../../services/profile-next-step-navigator';
import axios from 'axios';

export const handleNext = (
    event: React.SyntheticEvent<HTMLButtonElement>,
    state: State,
    dispatch: (dispatchEvent: DispatchEvent) => void,
    globalState: any,
    globalDispatch: (dispatchEvent: DispatchEvent) => void,
    sessionState: any,
    sessionDispatch: (dispatchEvent: DispatchEvent) => void
) => {
    event.preventDefault();
    logger.log(state.data['profile']);

    // Internal admin and institute admin can save Basic Information even if mandatory fields are blank.
    const isAdminLogin = isSuperAdmin() || isSchoolAdmin();

    const errorKeysToIgnore = getErrorsToIgnore(state);
    // const isImpersonatedSession = sessionStorage.getItem('is-impersonated-session') === 'YES';
    const customValidationPassed = isAdminLogin || isFormValidBasedOnCustomValidation(state, dispatch);
    const isNotValidMobile = !isAdminLogin && isMobileNotValid(state, dispatch);
    // let sessionData = { ...sessionState };

    // if (!isImpersonatedSession && !isFormValid(state, dispatch, errorKeysToIgnore)) {
    if (!isAdminLogin && (!isFormValid(state, dispatch, errorKeysToIgnore) || !customValidationPassed || isNotValidMobile)) {
        dispatch({ type: 'SHOW_ERRORS' });
        alert('Please correct the form errors!');
        return;
    }

    StudentService.pageSave(
        state.routeInfo.id,
        state.routeInfo.pageName,
        StudentService.toStudentEntity({
            id: state.routeInfo.id,
            // selectedInstitute: state?.data?.selectedInstitute,
            // userInstitutes: state?.data?.userInstitutes,
            user:{
                ...state?.data?.user,
                mobileNumber:state?.data?.profile.contactMobileNumber,
            },
            profile: {
                ...state?.data?.profile,
                pursuingEducationLevelCode: state?.data?.profile.presentEducationStatusCode == 'COMPLETED_STUDIES' ? null : state?.data?.profile.pursuingEducationLevelCode,
                highestCompletedEducationLevelCode: state?.data?.profile.presentEducationStatusCode != 'COMPLETED_STUDIES' ? null : state?.data?.profile.highestCompletedEducationLevelCode,
                contactEmailId: state?.data?.profile.contactEmailId,
                contactMobileNumber: state?.data?.profile.contactMobileNumber,
                contactMobileCountryCode: state?.data?.profile.contactMobileCountryCode,
            },
        })
    ).then(() => {
            
      //Send event only after saving the updated profile
       sendMoEngageEvent(state?.data);
       let studentId = sessionState.id || sessionState.studentId;

        // let menuType = getMenuType(state?.data?.profile);
        // state.actions['SET_MENU_TYPE'](menuType);

        // navigateToNextStep(AlumniProfileEditScreens.BASIC_INFORMATION, state, dispatch, sessionState);
        // setTimeout(() => {
        //     navigateToNextStep(AlumniProfileEditScreens.BASIC_INFORMATION, state, dispatch, sessionState);
        // }, 500);

        syncProfileMarker(state.routeInfo.id).then(() => {
            navigateToNextStep(AlumniProfileEditScreens.BASIC_INFORMATION, state, dispatch, sessionState, sessionDispatch);
        })
        
        // --------------start
        // if ( sessionState?.userStatusCode == 'ACTIVE' ) {
        //     state.actions['REDIRECT'](`/alumni/${studentId}/profile`);
        //     return;
        // }

        // const workStatusList = ['WORKING_FOR_A_COMPANY', 'PROFESSIONAL_PRACTICE', 'IN_DEFENCE', 'ENTREPRENEURSHIP'];

        // if ( workStatusList.includes(state?.data?.profile?.workingStatusCode) ) {
        //     state.actions['REDIRECT'](`/alumni/${studentId}/work`);
        //     return;
        // }

        // state.actions['REDIRECT'](`/alumni/${studentId}/outcome`);
        //-----------------end
    });
};

const isMobileNotValid = (state: State, dispatch: (dispatchEvent: DispatchEvent) => void) => {

    if (isEmpty(state?.data?.profile?.contactMobileCountryCode)) {
        setError('profile.contactMobileCountryCode', ['Please enter mobile code'], dispatch);
        return true;
    }

    if (isEmpty(state?.data?.profile?.contactMobileNumber)) {
        setError('profile.contactMobileNumber', ['Please enter mobile number'], dispatch);
        return true;
    }

    if (
        (state?.data?.profile?.contactMobileNumber?.length > 10 ||
            state?.data?.profile?.contactMobileNumber?.length < 10 ||
            parseInt(state?.data?.profile?.contactMobileNumber.charAt(0)) < 6) &&
        state?.data?.profile?.contactMobileCountryCode == 91
    ) {
        setError('profile.contactMobileNumber', ['Please enter a valid mobile number'], dispatch);
        return true;
    }

    if (
        (state?.data?.profile?.contactMobileNumber?.length > 15 ||
            state?.data?.profile?.contactMobileNumber?.length < 7 ||
            parseInt(state?.data?.profile?.contactMobileNumber.charAt(0)) < 1) &&
        state?.data?.profile?.contactMobileCountryCode != 91
    ) {
        setError('profile.contactMobileNumber', ['Please enter a valid mobile number'], dispatch);
        return true;
    }

    return false;
};

const getErrorsToIgnore = (state: State) => {
    if (state.data.profile.passOutYear > new Date().getFullYear() - 2 && state.data.profile.didYouTakeGapAfter12 === true)
        return ['profile.educationOrEmploymentCurrentStatusCode'];
};

export const onMobileNumberChange = (props: ControlOnChangeArguments) => {
    // console.log(props.value);
    const mobileCountryCode = props.row['contactMobileCountryCode']// || state?.data?.profile?.contactMobileCountryCode;
    const mobileNumber = props.value;

    if (mobileNumber?.length == 0) {
        props.errorMessages.push('Please enter mobile number');
        return;
    }

    //if (mobileCountryCode != '91') return;

    const errorMessage = 'Please enter a valid mobile number';

    if ((mobileNumber?.length > 10 || mobileNumber?.length < 10 || parseInt(props.value.charAt(0)) < 6) && mobileCountryCode == 91) {
        props.errorMessages.push(errorMessage);
    }

    if ((mobileNumber?.length > 15 || mobileNumber?.length < 7 || parseInt(props.value.charAt(0)) < 1) && mobileCountryCode != 91) {
        props.errorMessages.push(errorMessage);
    }
};

const sendMoEngageEvent = async (user:any) => {

    // console.log('============USER=================');
    // console.log(user);
    // return false;

    try {
        const response = await axios.post(`${process.env.REACT_APP_MOENGAGE_API}/moengage/moengage-basic-info`, {
            userInfo       : user
        });
        // console.log('Response:', response.data);
    } catch (error) {
        console.error('Error fetching data:', error);
    }
    // return false;
  };

export const onWorkingStatusCode = (props: ControlOnChangeArguments) => {
    if(props.value === 'NOT_WORKING') {

        props.dispatch({
            type: 'CONTROL_VALUE_CHANGE',
            payload: {
                dataKey: 'profile.workingStatusCode',
                value: 'NOT_WORKING',
            },
        });
    } else {

        props.dispatch({
            type: 'CONTROL_VALUE_CHANGE',
            payload: {
                dataKey: 'profile.workingStatusCode',
                value: '',
            },
        });

        props.dispatch({
            type: 'SET_FIELD_VALIDATION_ERRORS',
            payload: { dataKey: 'profile.workingStatusCode', errorMessages: ['Please select a working status'] },
        });
        
    }
}

const isFormValidBasedOnCustomValidation = (state: State, dispatch: (dispatchEvent: DispatchEvent) => void) => {
    const errorMessages = [] as any[];
    const universityIds = new Set();
    let isFormInvalid = false;

    // check if is working is selected or not if not throw the error
    
    if (!state?.data?.profile?.isWorking) {
        isFormInvalid = true;
       
        dispatch({
            type: 'SET_FIELD_VALIDATION_ERRORS',
            payload: { dataKey: 'profile.isWorking', errorMessages: ['Please select is working']  },
        });
    } else {
        dispatch({
            type: 'SET_FIELD_VALIDATION_ERRORS',
            payload: { dataKey: 'profile.isWorking', errorMessages: [] },
        });
    }

    // if present education is selected then check if pursuing education level or highest completed education level is selected based on the value of present education status code
    if (state?.data?.profile?.presentEducationStatusCode) {
        if (state?.data?.profile?.presentEducationStatusCode === 'COMPLETED_STUDIES' && !state?.data?.profile?.highestCompletedEducationLevelCode) {    
            isFormInvalid = true;
            errorMessages.push('Please select highest completed education level');
            dispatch({
                type: 'SET_FIELD_VALIDATION_ERRORS',
                payload: { dataKey: 'profile.highestCompletedEducationLevelCode', errorMessages },
            });

            dispatch({
                type: 'SET_FIELD_VALIDATION_ERRORS',
                payload: { dataKey: 'profile.pursuingEducationLevelCode', errorMessages: [] },
            });

        } // if pursuing then pursuing education level code should be selected
        else if (state?.data?.profile?.presentEducationStatusCode !== 'COMPLETED_STUDIES' && !state?.data?.profile?.pursuingEducationLevelCode) {
            isFormInvalid = true;
           
            dispatch({
                type: 'SET_FIELD_VALIDATION_ERRORS',
                payload: { dataKey: 'profile.pursuingEducationLevelCode', errorMessages: ['Please select pursuing education level']  },
            });
        }
    }
    
    // Custom validation for working status code, check if is working is wrking and working status code is not selected then show error
    if (state?.data?.profile?.isWorking === 'WORKING' && !state?.data?.profile?.workingStatusCode) {
        isFormInvalid = true;
        errorMessages.push('Please select a working status');
        dispatch({
            type: 'SET_FIELD_VALIDATION_ERRORS',
            payload: { dataKey: 'profile.workingStatusCode', errorMessages },
        });
    }
    return !isFormInvalid;
}
